import { render, staticRenderFns } from "./PesquisaAcesso.vue?vue&type=template&id=8e989ffa&scoped=true"
import script from "./PesquisaAcesso.vue?vue&type=script&lang=js"
export * from "./PesquisaAcesso.vue?vue&type=script&lang=js"
import style0 from "./PesquisaAcesso.vue?vue&type=style&index=0&id=8e989ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e989ffa",
  null
  
)

export default component.exports